import React from 'react';
import { Link } from 'react-router-dom';
import {
  ArrowRight, Clock3, CreditCard, RefreshCcw,
} from 'lucide-react';
import Reveal from './Reveal';

interface FinalCtaProps {
  ctaHref: string;
}

const reassurances = [
  { icon: CreditCard, label: 'No card required' },
  { icon: Clock3, label: 'Matched in 24 hours' },
  { icon: RefreshCcw, label: 'Switch tutor any time' },
];

const FinalCta: React.FC<FinalCtaProps> = ({ ctaHref }) => (
  <section className="section-shell pb-24 pt-4 sm:pb-32">
    <Reveal>
      <div className="relative isolate overflow-hidden rounded-4xl bg-ink-900 px-6 py-16 text-center sm:px-16 sm:py-20">
        <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10">
          <div className="absolute inset-0 bg-grid-dark bg-grid opacity-60" />
          <div className="absolute -left-24 -top-24 h-80 w-80 rounded-full bg-brand-500/40 blur-[100px]" />
          <div className="absolute -bottom-24 -right-16 h-80 w-80 rounded-full bg-brand-400/20 blur-[100px]" />
        </div>

        <h2 className="display mx-auto max-w-2xl text-balance text-4xl text-white sm:text-5xl">
          Your first lesson is
          {' '}
          <span className="italic text-brand-300">free</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-lg text-white/60">
          Tell us the subject and the goal. We&apos;ll find the tutor who has already
          sat that exact paper — and aced it.
        </p>

        <div className="mt-9 flex flex-col justify-center gap-3 sm:flex-row">
          <Link
            to={ctaHref}
            className="group inline-flex h-12 items-center justify-center gap-2 rounded-xl bg-white px-7 text-[15px] font-semibold text-ink-900 transition hover:bg-white/90 active:scale-[0.98]"
          >
            Book a free intro lesson
            <ArrowRight className="h-4 w-4 transition group-hover:translate-x-0.5" />
          </Link>
          <Link
            to="/contact"
            className="inline-flex h-12 items-center justify-center rounded-xl border border-white/20 px-7 text-[15px] font-semibold text-white transition hover:border-white/40 hover:bg-white/5 active:scale-[0.98]"
          >
            Talk to us first
          </Link>
        </div>

        <ul className="mt-10 flex flex-wrap items-center justify-center gap-x-7 gap-y-3">
          {reassurances.map((item) => (
            <li key={item.label} className="flex items-center gap-2 text-sm text-white/55">
              <item.icon className="h-4 w-4 text-brand-300" />
              {item.label}
            </li>
          ))}
        </ul>
      </div>
    </Reveal>
  </section>
);

export default FinalCta;
